// src/components/common/ConfirmAttestationBlock.js
//
// Extracted from ConfirmDialog.js (WAVE 1 · INTEGRATION-A, 2026-09-24) to make
// room for the action-beat routing without pushing that file past the
// 500-line cap — zero behavior change, same markup/tokens verbatim.
//
// The amber "verify this request" panel + the required checkbox that gates
// confirm, for security actions done on someone's behalf.

import { foundation } from '../../ui/tokens';
import CalmBanner from './notice/CalmBanner';
import LabeledCheckbox from './LabeledCheckbox';

const { spacePx } = foundation;

export default function ConfirmAttestationBlock({ attestation, attested, setAttested, busy, hasTypedField }) {
  if (!attestation) return null;
  return (
    <div style={{ marginBottom: hasTypedField ? spacePx[2] : spacePx[3] }}>
      <CalmBanner tone="error" role="note" style={{ marginBottom: spacePx[3] }}>{attestation.notice}</CalmBanner>
      <LabeledCheckbox
        checked={attested}
        disabled={busy}
        onChange={setAttested}
        testId="confirm-dialog-attestation"
        label={attestation.label}
      />
    </div>
  );
}
